import React, { Fragment } from 'react';

import { DocumentSectionListItem } from './DocumentSectionListItem';
import PropTypes from 'prop-types';

const renderList = (documentId, sections) => (
    <div>
        <table className="table table-hover table-sm">
            <thead>
                <tr>
                    <th scope="col">Section XPath</th>
                    <th scope="col">Administrators Comment</th>
                </tr>
            </thead>
            <tbody>
                {sections &&
                    sections.map((section, index) => renderListItem(documentId, section, index))}
            </tbody>
        </table>
    </div>
);

const renderListItem = (documentId, section, index) => (
    <Fragment key={documentId + '-' + index}>
        <DocumentSectionListItem
            sectionXpath={section.sectionXpath}
            sectionNote={section.sectionNote ? section.sectionNote : ''}
        />
    </Fragment>
);

const DocumentSectionList = props => (
    <Fragment>{renderList(props.documentId, props.sections)}</Fragment>
);

DocumentSectionList.propTypes = {
    documentId: PropTypes.string.isRequired,
    sections: PropTypes.array.isRequired,
};

export { DocumentSectionList };
